module.exports = __webpack_public_path__ + "static/fx_12.1f0932c2.jpg";